import Image from 'next/image';
import type { HTMLAttributes } from 'react';

import cn from '@/helper/cn';

import type { InfiniteScrollType } from '../constants/solutions';

type Props = HTMLAttributes<HTMLDivElement> & {
  items: InfiniteScrollType[];
  isMobile?: boolean;
};

const InfiniteScroll = ({
  items,
  isMobile = false,
  className,
  ...rest
}: Props) => {
  return (
    <div
      {...rest}
      className={cn(
        'inline-flex w-full flex-nowrap space-x-16 overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]',
        isMobile && 'space-x-8',
        className,
      )}
    >
      <ul
        className={cn(
          'flex animate-infinite-scroll items-center justify-center space-x-16 md:justify-start [&>li]:[list-style:none]',
          isMobile && 'animate-infinite-scroll-mobile space-x-8',
        )}
      >
        {items.map((item, index) => (
          <li key={`brand-${index}`}>
            <Image
              className="max-w-none"
              src={item.src}
              alt={item.alt}
              loading="eager"
              width={isMobile ? (item.width || 120) / 2 : item.width || 120}
              height={isMobile ? (item.height || 38) / 2 : item.height || 38}
            />
          </li>
        ))}
      </ul>
      <ul
        className={cn(
          'flex animate-infinite-scroll items-center justify-center space-x-16 md:justify-start [&>li]:[list-style:none]',
          isMobile && 'animate-infinite-scroll-mobile space-x-8',
        )}
        aria-hidden="true"
      >
        {items.map((item, index) => (
          <li key={`brand-${index}-duplicate`}>
            <Image
              className="max-w-none"
              src={item.src}
              alt={item.alt}
              loading="eager"
              width={isMobile ? (item.width || 120) / 2 : item.width || 120}
              height={isMobile ? (item.height || 38) / 2 : item.height || 38}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InfiniteScroll;
